/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.

import React, { useState, useCallback } from 'react';
import { Search } from '@elliemae/ds-icons';
import { DSInput } from '@elliemae/ds-legacy-form';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { DSIconSizes, DSIconColors } from '@elliemae/ds-icon';
import { debounce, noop } from 'lodash-es';
import { Grid } from '@elliemae/ds-grid';
import { SvgIcon as Logo } from '../Icons/EM_logo.js';
import { Container, Label, SearchWrapper, Icon, RightSection, MainSection } from './styles.js';
import { DSSideNav } from '../SideNav/index.js';

const DSGlobalHeader = ({
  containerProps = {},
  title,
  lastIcon,
  onSearchChange = noop,
  topMenuItems,
  bottomMenuItems,
}) => {
  const [searchBarVisible, setSearchBarVisible] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [showMenu, setShowMenu] = useState(false);
  const searchClicked = () => {
    setSearchBarVisible(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onSearchChangeDebounced = useCallback(debounce(onSearchChange, 250), []);
  const searchValueChanged = (e) => {
    const val = e.target.value;
    onSearchChangeDebounced(val);
    setSearchValue(val);
  };

  const searchCloseClicked = () => {
    setSearchBarVisible(false);
  };

  const menuToggle = (flag) => {
    setShowMenu(flag);
  };

  return (
    <>
      <Container data-testid={containerProps['data-testid'] || 'global-header-wrapper'} {...containerProps}>
        {!searchBarVisible ? (
          <MainSection>
            <Icon onClick={menuToggle.bind(null, true)}>{Logo()}</Icon>
            <Label>{title}</Label>
            <span></span>
            <RightSection>
              <Grid cols={lastIcon ? [1 / 2, 1 / 2] : [1]} gutter="xs">
                <Grid>
                  <Search
                    data-testid="mobile-global-header-search"
                    size={DSIconSizes.M}
                    color={DSIconColors.WHITE}
                    onClick={searchClicked}
                  />
                </Grid>
                {lastIcon && <Grid>{lastIcon}</Grid>}
              </Grid>
            </RightSection>
          </MainSection>
        ) : (
          <SearchWrapper>
            <DSInput
              clearable
              className="dsInput"
              placeholder="Search here"
              onChange={searchValueChanged}
              rightComponent={
                <DSButton
                  buttonType="primary"
                  className="dsButton"
                  icon={<Search size={DSIconSizes.M} color={DSIconColors.WHITE} onClick={searchCloseClicked} />}
                />
              }
              value={searchValue}
              variant="variant-active"
            />
          </SearchWrapper>
        )}
      </Container>
      {showMenu ? (
        <DSSideNav
          title={title}
          menuItems={topMenuItems}
          bottomMenuItems={bottomMenuItems}
          onClose={menuToggle.bind(null, false)}
        ></DSSideNav>
      ) : null}
    </>
  );
};

const menuProps = PropTypes.arrayOf(
  PropTypes.shape({
    icon: PropTypes.element,
    text: PropTypes.string,
  }),
).description('menu item array');

const props = {
  /** props to inject to wrapper */
  containerProps: PropTypes.object.description('props to inject to wrapper'),
  /**
   * Heading Title
   */
  title: PropTypes.string.isRequired.description('Heading Title'),
  /**
   * Dimsum icon Element
   */
  lastIcon: PropTypes.element.description('Dimsum icon Element'),
  /**
   * Callback function for search change
   */
  onSearchChange: PropTypes.func.description('Callback function for search change'),
  /**
   * Top Menu items array
   */
  topMenuItems: menuProps,
  /**
   * Bottom Menu items array
   */
  bottomMenuItems: menuProps,
};

DSGlobalHeader.displayName = 'DSGlobalHeader';
const DSGlobalHeaderWithSchema = describe(DSGlobalHeader);
DSGlobalHeaderWithSchema.propTypes = props;

export { DSGlobalHeader, DSGlobalHeaderWithSchema };
